<template>
  <div>
    <!-- 密码修改框 -->
    <ChangePasswordDialog v-if="visible('ChangePasswordDialog')" />
    <!-- 设置编辑框 -->
    <SettingDialog v-if="visible('SettingDialog')" />
    <!-- 注册编辑框 -->
    <RegisterDialog v-if="visible('RegisterDialog')" />
    <!-- 禁言编辑框 -->
    <EditChatBanDialog v-if="visible('EditChatBanDialog')" />

    <!-- 白名单编辑框 -->
    <EditWhiteListDialog v-if="visible('EditWhiteListDialog')" />

    <!-- 排行榜对话框 -->
    <LeaderboardDialog v-if="visible('LeaderboardDialog')" />

    <!-- 补单对话框 -->
    <CompensationOrderDialog v-if="visible('CompensationOrderDialog')" />

    <!-- 付费明细对话框 -->
    <OrdersInfoDialog v-if="visible('OrdersInfoDialog')" />

    <!-- 消费历史详情对话框 -->
    <ConsumeHistoriesDialog v-if="visible('ConsumeHistoriesDialog')" />

    <!-- 分区白名单编辑弹窗 -->
    <EditZoneWhiteDialog v-if="visible('EditZoneWhiteDialog')" />

    <!-- 打开查询累充最先抵达玩家对话框 -->
    <QueryTheFirstPlayerOfCostXYuanDialog v-if="visible('QueryTheFirstPlayerOfCostXYuanDialog')" />

    <!-- 强更新配置编辑弹窗 -->
    <EditForceUpdateConfigDialog v-if="visible('EditForceUpdateConfigDialog')" />

    <!-- 热更配置编辑框 -->
    <EditHotUpdateConfigDialog v-if="visible('EditHotUpdateConfigDialog')" />

    <!-- 定时邮件编辑框 -->
    <UpdateScheduledMailDialog v-if="visible('UpdateScheduledMailDialog')" />

    <!-- 新增禁言关键字弹窗 -->
    <AddChatBanKeywordsDialog v-if="visible('AddChatBanKeywordsDialog')" />

    <!-- 兑换码礼包编辑框 -->
    <EditRedeemCodeGiftDialog v-if="visible('EditRedeemCodeGiftDialog')" />
    <!-- 新增兑换码编辑框 -->
    <AddRedeemCodeDialog v-if="visible('AddRedeemCodeDialog')" />
    <!-- 兑换码礼包详情弹窗 -->
    <RedeemCodeGiftDetailsDialog v-if="visible('RedeemCodeGiftDetailsDialog')" />
    <!-- 渠道编辑框 -->
    <EditChannelConfigDialog v-if="visible('EditChannelConfigDialog')" />
    <!-- 合服编辑框 -->
    <MergeZonesDialog v-if="visible('MergeZonesDialog')" />
    <!-- 合服进度框 -->
    <MergeZonesProcessDialog v-if="visible('MergeZonesProcessDialog')" />
    <!--子分区框 -->
    <ChildZoneListPageDialog v-if="visible('ChildZoneListPageDialog')" />
    <!--分区编辑框 -->
    <EditZoneDialog v-if="visible('EditZoneDialog')" />
    <!--邮件附件编辑框 -->
    <EditMailPropsTemplateDialog v-if="visible('EditMailPropsTemplateDialog')" />
    <!--活动配置编辑框 -->
    <EditActivityTemplateDialog v-if="visible('EditActivityTemplateDialog')" />

    <!-- 批注编辑框 -->
    <EditMicrofilmDialog v-if="visible('EditMicrofilmDialog')" />

    <!-- 任务活动-进度宝箱框 -->
    <EditTaskActivityBoxDialog v-if="visible('EditTaskActivityBoxDialog')" />
    <!-- 任务活动-礼包编辑框 -->
    <EditTaskActivityGiftDialog v-if="visible('EditTaskActivityGiftDialog')" />
    <!-- 任务活动-商店编辑框 -->
    <EditTaskActivityShopDialog v-if="visible('EditTaskActivityShopDialog')" />
    <!-- 任务活动-任务编辑框 -->
    <EditTaskActivityTaskDialog v-if="visible('EditTaskActivityTaskDialog')" />

    <!--开服冲关活动-关卡进度编辑框 -->
    <EditBreakThroughLevelDialog v-if="visible('EditBreakThroughLevelDialog')" />
    <!--开服关卡排行榜活动-排名编辑框 -->
    <EditLevelLeaderBoardDialog v-if="visible('EditLevelLeaderBoardDialog')" />
    <!--累计充值活动-充值进度编辑框 -->
    <EditCumulativeRechargeOfLimitTimeDialog v-if="visible('EditCumulativeRechargeOfLimitTimeDialog')" />
    <!--累充返利编辑框 -->
    <EditAccumulatedRechargeRebateDialog v-if="visible('EditAccumulatedRechargeRebateDialog')" />
    <!--充值返利编辑框 -->
    <EditRechargeRebateDialog v-if="visible('EditRechargeRebateDialog')" />
    <!--永久累充返利编辑框 -->
    <EditForeverAccumulatedRechargeRebateDialog v-if="visible('EditForeverAccumulatedRechargeRebateDialog')" />
    <!--检测项编辑框 -->
    <EditDataMonitorDialog v-if="visible('EditDataMonitorDialog')" />
    <!--GM白名单编辑框 -->
    <EditWhiteListEntryOfGmDialog v-if="visible('EditWhiteListEntryOfGmDialog')" />
    <!--企业成员编辑框 -->
    <EditCorpMemberDialog v-if="visible('EditCorpMemberDialog')" />
    <!--企业事件通知人编辑框 -->
    <EditCorpEventReceiverDialog v-if="visible('EditCorpEventReceiverDialog')" />
    <!--获取企业用户的userID对话框 -->
    <GetUserIdDialog v-if="visible('GetUserIdDialog')" />

    <!-- 版本邮件编辑框 -->
    <EditVersionMailDialog v-if="visible('EditVersionMailDialog')" />
  </div>
</template>

<script>
import GetUserIdDialog from "@/components/dialogs/GetUserIdDialog";
import RegisterDialog from "@/components/dialogs/RegisterDialog";
import SettingDialog from "@/components/dialogs/SettingDialog";
import EditMicrofilmDialog from "@/components/dialogs/EditMicrofilmDialog";
import ChangePasswordDialog from "@/components/dialogs/ChangePasswordDialog";
import EditChatBanDialog from "@/pages/chat/EditChatBanDialog";
import EditWhiteListDialog from "@/pages/player/tab-pages/dialog/EditWhiteListDialog";
import LeaderboardDialog from "@/pages/zone/LeaderboardDialog";
import CompensationOrderDialog from "@/pages/player/tab-pages/dialog/CompensationOrderDialog";
import OrdersInfoDialog from "@/pages/player/tab-pages/dialog/OrdersInfoDialog";
import ConsumeHistoriesDialog from "@/pages/player/tab-pages/dialog/ConsumeHistoriesDialog";
import EditZoneWhiteDialog from "@/pages/player/tab-pages/dialog/EditZoneWhiteDialog";
import QueryTheFirstPlayerOfCostXYuanDialog from "@/pages/zone/QueryTheFirstPlayerOfCostXYuanDialog";
import EditForceUpdateConfigDialog from "@/pages/version/tab-pages/EditForceUpdateConfigDialog";
import EditHotUpdateConfigDialog from "@/pages/version/tab-pages/EditHotUpdateConfigDialog";
import UpdateScheduledMailDialog from "@/pages/mail/UpdateScheduledMailDialog";
import AddChatBanKeywordsDialog from "@/pages/chat/AddChatBanKeywordsDialog";
import EditRedeemCodeGiftDialog from "@/pages/redeem-code/EditRedeemCodeGiftDialog";
import AddRedeemCodeDialog from "@/pages/redeem-code/AddRedeemCodeDialog";
import RedeemCodeGiftDetailsDialog from "@/pages/redeem-code/RedeemCodeGiftDetailsDialog";
import EditChannelConfigDialog from "@/pages/system-config/EditChannelConfigDialog";
import MergeZonesDialog from "@/pages/system-config/MergeZonesDialog";
import MergeZonesProcessDialog from "@/pages/system-config/MergeZonesProcessDialog";
import ChildZoneListPageDialog from "@/pages/zone/ChildZoneListPageDialog";
import EditZoneDialog from "@/pages/zone/EditZoneDialog";
import EditMailPropsTemplateDialog from "@/pages/mail/tab-pages/dialog/EditMailPropsTemplateDialog";
import EditActivityTemplateDialog from "@/pages/activity/EditActivityTemplateDialog";
import EditTaskActivityBoxDialog from "@/pages/activity/activity_parameter_template/dialog/task_activity/EditTaskActivityBoxDialog";
import EditTaskActivityGiftDialog from "@/pages/activity/activity_parameter_template/dialog/task_activity/EditTaskActivityGiftDialog";
import EditTaskActivityShopDialog from "@/pages/activity/activity_parameter_template/dialog/task_activity/EditTaskActivityShopDialog";
import EditTaskActivityTaskDialog from "@/pages/activity/activity_parameter_template/dialog/task_activity/EditTaskActivityTaskDialog";
import EditBreakThroughLevelDialog from "@/pages/activity/activity_parameter_template/dialog/EditBreakThroughLevelDialog";
import EditCumulativeRechargeOfLimitTimeDialog from "@/pages/activity/activity_parameter_template/dialog/EditCumulativeRechargeOfLimitTimeDialog";
import EditLevelLeaderBoardDialog from "@/pages/activity/activity_parameter_template/dialog/EditLevelLeaderBoardDialog";
import EditAccumulatedRechargeRebateDialog from "@/pages/activity/activity_parameter_template/dialog/EditAccumulatedRechargeRebateDialog";
import EditRechargeRebateDialog from "@/pages/activity/activity_parameter_template/dialog/EditRechargeRebateDialog";
import EditForeverAccumulatedRechargeRebateDialog from "@/pages/activity/activity_parameter_template/dialog/EditForeverAccumulatedRechargeRebateDialog";
import EditDataMonitorDialog from "@/pages/player/tab-pages/dialog/EditDataMonitorDialog";
import EditWhiteListEntryOfGmDialog from "@/pages/player/tab-pages/dialog/EditWhiteListEntryOfGmDialog";
import EditCorpMemberDialog from "@/pages/corp-flow/tab-pages/dialog/EditCorpMemberDialog";
import EditCorpEventReceiverDialog from "@/pages/corp-flow/tab-pages/dialog/EditCorpEventReceiverDialog";
import EditVersionMailDialog from "@/pages/mail/tab-pages/dialog/EditVersionMailDialog";

export default {
  components: {
    ChangePasswordDialog,
    EditChatBanDialog,
    EditWhiteListDialog,
    LeaderboardDialog,
    CompensationOrderDialog,
    OrdersInfoDialog,
    ConsumeHistoriesDialog,
    EditZoneWhiteDialog,
    QueryTheFirstPlayerOfCostXYuanDialog,
    EditForceUpdateConfigDialog,
    EditHotUpdateConfigDialog,
    UpdateScheduledMailDialog,
    AddChatBanKeywordsDialog,
    EditRedeemCodeGiftDialog,
    AddRedeemCodeDialog,
    RedeemCodeGiftDetailsDialog,
    EditChannelConfigDialog,
    MergeZonesDialog,
    MergeZonesProcessDialog,
    ChildZoneListPageDialog,
    EditZoneDialog,
    EditMailPropsTemplateDialog,
    EditActivityTemplateDialog,
    EditMicrofilmDialog,
    EditTaskActivityBoxDialog,
    EditTaskActivityGiftDialog,
    EditTaskActivityShopDialog,
    EditTaskActivityTaskDialog,
    EditBreakThroughLevelDialog,
    EditCumulativeRechargeOfLimitTimeDialog,
    EditLevelLeaderBoardDialog,
    EditAccumulatedRechargeRebateDialog,
    EditRechargeRebateDialog,
    EditForeverAccumulatedRechargeRebateDialog,
    EditDataMonitorDialog,
    EditWhiteListEntryOfGmDialog,
    EditCorpMemberDialog,
    EditCorpEventReceiverDialog,
    SettingDialog,
    RegisterDialog,
    GetUserIdDialog,
    EditVersionMailDialog,
  },
  methods: {
    visible(name) {
      if (this.$dialogutil.visible(name) == undefined) {
        this.$dialogutil.registerModule(name);
      }
      return this.$dialogutil.visible(name);
    },
  },
};
</script>
